"use client";
import "./Learning_Without_Limits.css";
import { Container, Row, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const stats = [
  {
    number: "25+",
    title: "Startup Showcases",
  },
  {
    number: "60+",
    title: "University Partnerships",
  },
  {
    number: "500+",
    title: "Hiring Partners",
  },
  {
    number: "1,200+",
    title: "Alumni Start-ups",
  },
];

const speakers = [
  {
    name: "Falguni Nayar",
    role: "Founder",
    image: "/assets/images/learnwithoutlimit/falguninayar.webp",
  },
  {
    name: "N. Chandrasekaran",
    role: "Chairman",
    image: "/assets/images/learnwithoutlimit/chandrashekharan.webp",
  },
  {
    name: "Tim Cook",
    role: "CEO",
    image: "/assets/images/learnwithoutlimit/timcook.webp",
  },
  {
    name: "Karan Johar",
    role: "Filmmaker",
    image: "/assets/images/learnwithoutlimit/karanjohar.webp",
  },
  {
    name: "Piyush Bansal",
    role: "Industry Leader",
    image: "/assets/images/learnwithoutlimit/piyushbansal.webp",
  },
];

export default function LearningWithoutLimits() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <section className="learning_section" id="learningwithoutlimits">
      <Container>
        <Row>
          {/* <span className="learning_small">
              Learning Without
            </span>

            <h2 className="learning_title">
              Limits
            </h2> */}
          <CommonHeading
            subTitle=" Interact With"
            title=" Global Business Leaders"
            // description="From AI-first learning to global exposure, every experience is designed to give you an edge in the business world."
          />

          <p className="learning_desc">
            Every experience is designed to bring business closer to you. Learn
            through live projects, industry interactions, masterclasses and
            mentorship that prepare you for what's next.
          </p>
          {/* 
            <Row className="stats_row">

              {stats.map((item, index) => (
                <Col lg={3} xs={6} key={index}>
                  <div className="stat_box">
                    <h3>{item.number}</h3>
                    <p>{item.title}</p>
                  </div>
                </Col>
              ))}

            </Row> */}

          <Col lg={8}></Col>
        </Row>

        <Row className="align-items-center mt-2">
          <Col lg={4}>
            <div className="insight_content">
              <h3>
                Insights Beyond
                <br />
                <span>the Classroom</span>
              </h3>

              <p>
                We bring industry leaders, innovators and change-makers to share
                real-world perspectives and broaden horizons.
              </p>
            </div>
          </Col>

          <Col lg={8}>
            <Swiper
              modules={[Autoplay]}
              loop={true}
              speed={700}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              spaceBetween={18}
              breakpoints={{
                320: {
                  slidesPerView: 1.5,
                },
                576: {
                  slidesPerView: 2.2,
                },
                768: {
                  slidesPerView: 3,
                },
                1200: {
                  slidesPerView: 3,
                },
              }}
            >
              {speakers.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="speaker_card">
                    <img src={item.image} alt={item.name} />

                    <div className="speaker_overlay">
                      <h4>{item.name}</h4>

                      <span>{item.role}</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
